import { render, staticRenderFns } from "./QuestionnaireGatewayCpt.vue?vue&type=template&id=f34c5ce2&scoped=true&"
import script from "./QuestionnaireGatewayCpt.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireGatewayCpt.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireGatewayCpt.vue?vue&type=style&index=0&id=f34c5ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34c5ce2",
  null
  
)

export default component.exports